module.exports = __webpack_public_path__ + "img/hontai_VanilaWhite.edab00fe.png";